import _ from 'lodash'
import { get } from 'lodash/fp'
import { useState } from 'react'
import { connect } from 'react-redux'
import { Button } from 'reactstrap'
import { bindActionCreators } from 'redux'

import MESSAGES from 'core/data-model/constants/messages'
import values from 'core/data-model/constants/values'
import { validateAdvisorPermission, validateUserStartedJourney } from 'core/service/distributor/permission'
import { getAppConfig } from 'deploy-env/app-config'
import Icon from 'e-submission/components/Icon'
import { getAdvisor } from 'e-submission/domain/service'
import { IsRealDevice } from 'e-submission/utils'
import { selectFSE, updateOffice } from 'identity/actions'
import { FSEBranchModal } from 'identity/fse-branch/components'
import {
  getIdentityUser,
  getSelectedFSE,
  getSelectedOffice,
  getUserAgentType,
  getUserDistributorGroup,
  isLoggedIn,
} from 'identity/selectors'
import { withModalToggle } from 'lib/with-hoc'
import {
  loginRequest,
  setProcessingApp,
  setProcessingSuccess,
  startStandardSelling,
  unsetProcessing,
} from 'quick-quote/actions'
import { InformationBranchModal } from 'quick-quote/components'
import { getEntryComponent } from 'quick-quote/entry-component/selectors'
import { getToggles } from 'quick-quote/feature-toggles'
import { isCompletedMarketConducts } from 'quick-quote/fna/market-conducts/selectors'
import { isCompletedNeedGap } from 'quick-quote/fna/need-and-gap-analysis/selectors'
import { setNotificationMessage } from 'quick-quote/notification/actions'
import { isMRTAProduct, isGLTSPProduct } from 'quick-quote/product-mrta/coverage-plan/selectors'
import { getSelectedBasicCategory, getSelectedDisplayBasicPlanCode } from 'quick-quote/product-selection/selectors'
import {
  getAllowedAgentTypes,
  getIsAllowRemoteSelling,
  getValidatedEnteringESubRules,
  isBlockedEnteringESub,
  isProcessing,
  isNeedToCompleteFNA,
} from 'quick-quote/selectors'

import { hideLoading, showLoading } from 'e-submission/apps/actions'

export const _ESubmitButton = (props) => {
  const [ isInfoOpen, toggleInfo ] = useState()
  const createApplication = () => {
    props.startStandardSelling()
  }

  const agentType = get('profile.agent_type', props.user)
  const agentCode = get('profile.agent_code', props.user)

  const localClickSubmit = async () => {
    try {
      if (!props.isLoggedIn) return props.loginRequest()
      if (props.isNeedToCompleteFNA && !(props.isMRTAProduct || props.isGLTSPProduct)) {
        props.setNotificationMessage({
          type: 'ErrorIncompleteFNA',
          incompleteNeedGap: !props.isCompletedNeedGap,
          incompleteMarketConducts: !props.isCompletedMarketConducts,
        })
        props.setProcessingSuccess()
        return
      }

      props.setProcessingApp()

      // Login is required before calling this request
      const advisor = await props.requestAdvisorStatus(props.user, agentCode, agentType)

      if (!isAllowAgent(advisor) || !isAllowAdvisor(advisor) || !isUserStartedJourneyFromCorrectApp(advisor)) {
        props.setProcessingSuccess()
        return
      }

      //Not good logic to validated rules here but requirement can't changed
      //Just suggestion : In future we should add logic at selector "isBlockedEnteringESub"
      //and disabled button and make getMessageErrors to show on third page (BI).
      //Now Third page (BI) just fixed message error. It should change to dynamic message by error that we get.
      if (props.validatedEnteringESubRules.length > 0) {
        showErrorEnteringMesasge(props.validatedEnteringESubRules[0])
        props.setProcessingSuccess()
        return
      }

      if (isFSE()) {
        props.setProcessingSuccess()
        return props.toggleModal()
      }

      if (getToggles().ENABLE_REMOTE_SELLING && props.isAllowRemoteSelling) {
        return getToggles().ENABLE_FNA_PHASE2
          ? props.setNotificationMessage({ type: 'RemoteSellingVc' })
          : props.setNotificationMessage({ type: 'RemoteSelling' })
      } else if (!props.isAllowRemoteSelling && getToggles().ENABLE_FNA_PHASE2) {
        return props.setNotificationMessage({ type: 'RemoteSellingVc' })
      } else {
        createApplication()
      }
    } catch (error) {
      console.warn(error)
      get('response.status', error) === 403
        ? props.setNotificationMessage({ type: 'AuthenticationError' })
        : showGenericError(error)

      props.setProcessingSuccess()
      return false
    }
  }

  const localClickCloneApp = async () => {
    try {
      props.showLoading()
      if (!props.isLoggedIn) return props.loginRequest()
      if (props.isNeedToCompleteFNA && !(props.isMRTAProduct || props.isGLTSPProduct)) {
        props.setNotificationMessage({
          type: 'ErrorIncompleteFNA',
          incompleteNeedGap: !props.isCompletedNeedGap,
          incompleteMarketConducts: !props.isCompletedMarketConducts,
        })
        props.setProcessingSuccess()
        return
      }

      props.setProcessingApp()

      // Login is required before calling this request
      const advisor = await props.requestAdvisorStatus(props.user, agentCode, agentType)

      if (!isAllowAgent(advisor) || !isAllowAdvisor(advisor) || !isUserStartedJourneyFromCorrectApp(advisor)) {
        props.setProcessingSuccess()
        return
      }

      //Not good logic to validated rules here but requirement can't changed
      //Just suggestion : In future we should add logic at selector "isBlockedEnteringESub"
      //and disabled button and make getMessageErrors to show on third page (BI).
      //Now Third page (BI) just fixed message error. It should change to dynamic message by error that we get.
      if (props.validatedEnteringESubRules.length > 0) {
        showErrorEnteringMesasge(props.validatedEnteringESubRules[0])
        props.setProcessingSuccess()
        return
      }

      if (isFSE()) {
        props.setProcessingSuccess()
        return props.toggleModal()
      }

      props.hideLoading()

      return props.setNotificationMessage({ type: 'SearchAppByIdNoModal' })
    } catch (error) {
      console.warn(error)
      get('response.status', error) === 403
        ? props.setNotificationMessage({ type: 'AuthenticationError' })
        : showGenericError(error)

      props.hideLoading()

      props.setProcessingSuccess()
      return false
    }
  }

  const allowedDistributorTypes = props.allowedAgentTypes

  const isAllowAgent = (advisor) => {
    const advisorType = _.get(advisor, 'type.code')
    const isCorrectType = allowedDistributorTypes.includes(advisorType)
    if (!isCorrectType) {
      showNotAllowMessage()
      return false
    }
    return true
  }

  const isUserStartedJourneyFromCorrectApp = (advisor) => {
    const advisorType = _.get(advisor, 'type.code')
    if (!validateUserStartedJourney(advisorType, props.entryComponent)) {
      showOnlyAllowFromPaMesasge()
      return false
    }
    return true
  }

  const isAllowAdvisor = (advisor) => {
    if (!validateAdvisorPermission(advisor, allowedDistributorTypes)) {
      showNotAllowMessage()
      return false
    }
    return true
  }

  const showOnlyAllowFromPaMesasge = () => {
    props.setNotificationMessage({
      title: MESSAGES.ONLY_ALLOW_FROM_PA.TITLE,
      message: MESSAGES.ONLY_ALLOW_FROM_PA.DESCRIPTION,
      type: 'ErrorMessage',
    })
  }

  const showNotAllowMessage = () => {
    props.setNotificationMessage({
      title: MESSAGES.NOT_ALLOW_ESUBMISSION.TITLE,
      message: MESSAGES.NOT_ALLOW_ESUBMISSION.DESCRIPTION,
      type: 'ErrorMessage',
    })
  }

  const showErrorEnteringMesasge = (message) => {
    props.setNotificationMessage({
      title: MESSAGES.NOT_ALLOW_ESUBMISSION.TITLE,
      message: message,
      type: 'ErrorMessage',
    })
  }

  const showGenericError = (error) => {
    const notificationMessage = getToggles().ENABLE_RED_TRUCK_ERROR_MSG
      ? { type: 'GenericError', message: error.message }
      : { type: 'GenericError' }
    props.setNotificationMessage(notificationMessage)
  }

  const isFSE = () => get('userDistributorGroup', props) === 'BANC'
  const fseBranchModal = isFSE() ? (
    <FSEBranchModal
      isModalOpen={props.isModalOpen}
      toggleModal={() => {
        props.unsetProcessing()
        props.toggleModal()
      }}
      submitAction={() => toggleInfo(true)}
      selectFSE={props.selectFSE}
      updateOffice={props.updateOffice}
      selectedOffice={props.selectedOffice}
      selectedFSE={props.selectedFSE}
      user={props.user}
      setNotificationMessage={props.setNotificationMessage}
    />
  ) : null
  const informationBranchModal = (
    <InformationBranchModal
      isModalOpen={isInfoOpen}
      toggleModal={() => toggleInfo(false)}
      submitAction={() => {
        if (props.isMRTAProduct || props.isGLTSPProduct) {
          props.startStandardSelling()
        } else if (getToggles().ENABLE_FNA_PHASE2) {
          props.setNotificationMessage({ type: 'RemoteSellingVc' })
        } else {
          props.toggleModal()
          props.startStandardSelling()
        }
      }}
    />
  )

  /* istanbul ignore next */
  const isBanca = props.currentUserRole === values.AGENT_TYPE_LB

  const isDisabledButton = props.isBlockedEnteringESub || props.isProcessing
  const RealButton = (
    <>
      {!isBanca && (
        <Button
          className="clone-app"
          color={props.isBlockedEnteringESub ? 'disabled' : 'outline-primary'}
          disabled={isDisabledButton}
          onClick={localClickCloneApp}
        >
          <Icon.cloneApp className={`clone-icon ${props.isBlockedEnteringESub ? 'disabled-icon' : ''}`} />
          คัดลอกข้อมูล
        </Button>
      )}
      <Button
        className="e-submission"
        color={props.isBlockedEnteringESub ? 'disabled' : 'primary'}
        disabled={isDisabledButton}
        onClick={localClickSubmit}
      >
        {MESSAGES.ESUBMISSION}
        {fseBranchModal}
        {informationBranchModal}
      </Button>
    </>
  )

  if (isBanca) {
    // Not allow Banca to use web view to esubmission flow
    if (!IsRealDevice && getToggles().ENABLE_BANCA_BLOCK_ESUB_WEB_VIEW) return null

    // Not allow Banca to use except product in list to allow
    if (
      getToggles().ENABLE_ESUB_BTN_FOR_LB_WITH_PRODUCTLIST &&
      (getAppConfig().ESUB_BTN_FOR_LB_WITH_PRODUCTLIST.includes(props.basicPlanCode) ||
        getAppConfig().ESUB_BTN_FOR_LB_WITH_PRODUCTCATEGORY.includes(props.productCategory))
    ) {
      return RealButton
    } else {
      return null
    }
  } else if (props.currentUserRole === values.AGENT_TYPE_FSE || props.currentUserRole === values.AGENT_TYPE_BANCA) {
    return null
  }

  return RealButton
}

const mapStateToProps = (state) => ({
  isLoggedIn: isLoggedIn(state),
  user: getIdentityUser(state),
  currentUserRole: getUserAgentType(state),
  userDistributorGroup: getUserDistributorGroup(state),
  selectedFSE: getSelectedFSE(state),
  selectedOffice: getSelectedOffice(state),
  isBlockedEnteringESub: isBlockedEnteringESub(state),
  isProcessing: isProcessing(state),
  productCategory: getSelectedBasicCategory(state),
  allowedAgentTypes: getAllowedAgentTypes(state),
  entryComponent: getEntryComponent(state),
  isAllowRemoteSelling: getIsAllowRemoteSelling(state),
  validatedEnteringESubRules: getValidatedEnteringESubRules(state),
  isNeedToCompleteFNA: isNeedToCompleteFNA(state),
  isCompletedNeedGap: isCompletedNeedGap(state),
  isCompletedMarketConducts: isCompletedMarketConducts(state),
  selectedRemoteSelling: false,
  basicPlanCode: getSelectedDisplayBasicPlanCode(state),
  isMRTAProduct: isMRTAProduct(state),
  isGLTSPProduct: isGLTSPProduct(state),
})

const mapDispatchToProps = (dispatch) => ({
  setProcessingApp: bindActionCreators(setProcessingApp, dispatch),
  setProcessingSuccess: bindActionCreators(setProcessingSuccess, dispatch),
  unsetProcessing: bindActionCreators(unsetProcessing, dispatch),
  loginRequest: bindActionCreators(loginRequest, dispatch),
  startStandardSelling: bindActionCreators(startStandardSelling, dispatch),
  requestAdvisorStatus: async (user, agentId, agentType) => {
    return await getAdvisor(user, agentId, agentType)
  },
  selectFSE: bindActionCreators(selectFSE, dispatch),
  updateOffice: bindActionCreators(updateOffice, dispatch),
  setNotificationMessage: bindActionCreators(setNotificationMessage, dispatch),
  showLoading: bindActionCreators(showLoading, dispatch),
  hideLoading: bindActionCreators(hideLoading, dispatch),
})

export default connect(mapStateToProps, mapDispatchToProps)(withModalToggle(_ESubmitButton))
